import { Languages } from '../languages'

export enum LabelMessages {
  INTRODUCTION = 'INTRODUCTION',
  AUTHENTICATION = 'AUTHENTICATION',
  APIS = 'APIS',
  Downloads = 'Downloads',
  ENERGY_DATA_API = 'ENERGY_DATA_API',
  DATA_EXPORT_API = 'DATA_EXPORT_API',
  MASKINPORTEN = 'MASKINPORTEN',
  QUICK_START = 'QUICK_START',
  RESOURCES = 'RESOURCES',
  OVERVIEW = 'OVERVIEW',
  ENDPOINTS = 'ENDPOINTS',
  FAQ = 'FAQ',
  TERMS_OF_USE = 'TERMS_OF_USE',
  FEEDBACK = 'FEEDBACK',
  GETTING_STARTED = 'GETTING_STARTED',
  CREATE_CLIENT = 'CREATE_CLIENT',
  SCOPES = 'SCOPES',
  ENERGY_DATA = 'ENERGY_DATA',
  CHANGE_LOG = 'CHANGE_LOG',
  DATA_EXPORT = 'DATA_EXPORT',
  TRY_IT_OUT = 'TRY_IT_OUT',
  ALL = 'ALL',
  ONE = 'ONE',
  EXPORT = 'EXPORT',
}

export type IncludedLabelMessages = {
  [P in LabelMessages]: {
    [P in Languages]: string
  }
}

export const translatedLabelMessages: IncludedLabelMessages = {
  [LabelMessages.INTRODUCTION]: {
    en: 'Introduction'
  },

  [LabelMessages.AUTHENTICATION]: {
    en: 'Authentication'
  },

  [LabelMessages.APIS]: {
    en: 'APIs'
  },

  [LabelMessages.Downloads]: {
    en: 'Downloads'
  },

  [LabelMessages.ENERGY_DATA_API]: {
    en: 'Energy Data API'
  },

  [LabelMessages.DATA_EXPORT_API]: {
    en: 'Data Export API'
  },

  [LabelMessages.MASKINPORTEN]: {
    en: 'Maskinporten'
  },

  [LabelMessages.QUICK_START]: {
    en: 'Quick start'
  },

  [LabelMessages.RESOURCES]: {
    en: 'Resources'
  },

  [LabelMessages.OVERVIEW]: {
    en: 'Overview'
  },

  [LabelMessages.ENDPOINTS]: {
    en: 'Endpoints'
  },

  [LabelMessages.FAQ]: {
    en: 'FAQ'
  },

  [LabelMessages.TERMS_OF_USE]: {
    en: 'Terms of use'
  },

  [LabelMessages.FEEDBACK]: {
    en: 'Feedback'
  },

  [LabelMessages.GETTING_STARTED]: {
    en: 'Getting started'
  },

  [LabelMessages.CREATE_CLIENT]: {
    en: 'Creating a client and testing'
  },

  [LabelMessages.SCOPES]: {
    en: 'Scopes and restricted datasets'
  },

  [LabelMessages.ENERGY_DATA]: {
    en: 'Energy data API'
  },

  [LabelMessages.CHANGE_LOG]: {
    en: 'Change logs'
  },

  [LabelMessages.DATA_EXPORT]: {
    en: 'Data Export API'
  },

  [LabelMessages.TRY_IT_OUT]: {
    en: 'Try it out'
  },

  [LabelMessages.ALL]: {
    en: 'All'
  },

  [LabelMessages.ONE]: {
    en: 'One'
  },

  [LabelMessages.EXPORT]: {
    en: 'Export'
  }
}
